export const supportedPhoneURLParams = [
  { param: 'brand', category: 'standard-brand', filterGroup: 'standard' },
  {
    param: 'carrier',
    category: 'standard-carrier',
    filterGroup: 'standard',
  },
  {
    param: 'deviceCategory',
    category: 'standard-deviceCategory',
    filterGroup: 'standard',
  },
  {
    param: 'operatingSystem',
    category: 'standard-operatingSystem',
    filterGroup: 'standard',
  },
  {
    param: 'offers',
    category: 'standard-offers',
    filterGroup: 'standard',
  },
  {
    param: 'battery',
    category: 'advanced-battery',
    filterGroup: 'advanced',
  },
  {
    param: 'camera',
    category: 'advanced-camera',
    filterGroup: 'advanced',
  },
  {
    param: 'storage',
    category: 'advanced-storage',
    filterGroup: 'advanced',
  },
  {
    param: 'screenSize',
    category: 'advanced-screenSize',
    filterGroup: 'advanced',
  },
];

export const createFilterStateFromURL = (
  urlSearchParams: URLSearchParams,
  storedFilters: Record<string, any>,
  defaultFilters: Record<string, any>,
) => {
  const paramInURL = supportedPhoneURLParams.reduce<Record<string, any>[]>(
    (acc, param) => {
      acc.push({
        ...param,
        value: urlSearchParams.get(param.param),
      });
      return acc;
    },
    [],
  );
  const paramExists = paramInURL.find((param) => param.value);
  if (!paramExists) {
    return defaultFilters;
  }
  const newFilters = paramInURL.reduce(
    (acc, { value, category, filterGroup }) => {
      if (value == null) {
        return {
          ...acc,
          [filterGroup]: {
            ...acc[filterGroup],
            [category]: {
              ...Object.keys(acc[filterGroup][category]).reduce(
                (reset, key) => {
                  reset[key] = false;
                  return reset;
                },
                {},
              ),
            },
          },
        };
      }
      const values = value.split(' ');
      const selectedFilters = values.reduce((selectedFilter, val) => {
        selectedFilter[`${category}-${val}`] = true;
        return selectedFilter;
      }, {});
      const updatedFilters = {
        ...acc,
        [filterGroup]: {
          ...acc[filterGroup],
          [category]: {
            ...Object.keys(acc[filterGroup][category]).reduce((reset, key) => {
              reset[key] = false;
              return reset;
            }, {}),
            ...selectedFilters,
          },
        },
      };
      return updatedFilters;
    },
    Object.keys(storedFilters).length > 1 ? storedFilters : defaultFilters,
  );
  return newFilters;
};
